/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import type {
  DisciplinaryActionDto,
  GetAllDisciplinaryActionsParams,
  IReadOnlyListOfDisciplinaryActionDto
} from '../models';

import { customInstance } from '../axios';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Returns all disciplinary actions enumeration values, with an optional filter.
 */
export const getAllDisciplinaryActions = (
    params?: GetAllDisciplinaryActionsParams,
 options?: SecondParameter<typeof customInstance<IReadOnlyListOfDisciplinaryActionDto>>,) => {
      return customInstance<IReadOnlyListOfDisciplinaryActionDto>(
      {url: `/incident-management/disciplinary-actions`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Returns the DisciplinaryAction identified by the route id.
 */
export const getDisciplinaryActionById = (
    id: number,
 options?: SecondParameter<typeof customInstance<DisciplinaryActionDto>>,) => {
      return customInstance<DisciplinaryActionDto>(
      {url: `/incident-management/disciplinary-actions/${id}`, method: 'GET'
    },
      options);
    }
  export type GetAllDisciplinaryActionsResult = NonNullable<Awaited<ReturnType<typeof getAllDisciplinaryActions>>>
export type GetDisciplinaryActionByIdResult = NonNullable<Awaited<ReturnType<typeof getDisciplinaryActionById>>>
